import DocDocument from "@shared/svg/doc-document.svg?react";
import EmlDocument from "@shared/svg/eml-document.svg?react";
import EpubDocument from "@shared/svg/epub-document.svg?react";
import HtmlDocument from "@shared/svg/html-document.svg?react";
import ImageDocument from "@shared/svg/image-document.svg?react";
import JsonDocument from "@shared/svg/json-document.svg?react";
import LxmlDocument from "@shared/svg/lxml-document.svg?react";
import MdDocument from "@shared/svg/md-document.svg?react";
import OdtDocument from "@shared/svg/odt-document.svg?react";
import PbDocument from "@shared/svg/pb-document.svg?react";
import PdfDocument from "@shared/svg/pdf-document.svg?react";
import PptDocument from "@shared/svg/ppt-document.svg?react";
import RtfDocument from "@shared/svg/rtf-document.svg?react";
import TxtDocument from "@shared/svg/txt-document.svg?react";
import VideoDocument from "@shared/svg/video.svg?react";
import XlsDocument from "@shared/svg/xls-document.svg?react";

export const EMAIL_FOLDER_KEY = "EmailFolderId";

export const EMAIL_ATTACHMENT_DOWNLOADING_TOAST_ID =
  "email-attachment-downloading-toast";

export const EMAIL_ATTACHMENT_DOWNLOAD_IDENTIFIER = "downloadEmailFile";

export const SELECTED_EMAIL_LOCAL_STORAGE_ITEM = "selected_email";

export const EMAIL_ACCOUNT_STATUSES = {
  CONNECTED: "connected",
  DELETED: "deleted",
  EXPIRED: "expired",
};

export const EMAIL_FOLDER_TYPES = {
  INBOX: "Inbox",
  DRAFTS: "Drafts",
  DRAFT: "Draft",
  SENT_ITEMS: "Sent Items",
  SENT: "Sent",
  OUTBOX: "Outbox",
  DELETED_ITEMS: "Deleted Items",
  TRASH: "Trash",
  JUNK_EMAIL: "Junk Email",
  SPAM: "Spam",
};

export const EMAIL_FOLDER_ATTRIBUTE_TYPES = {
  INBOX: "\\Inbox",
  DRAFT: "\\Drafts",
  SENT: "\\Sent",
  OUTBOX: "\\Outbox",
  TRASH: "\\Trash",
  SPAM: "\\Junk",
  ARCHIVE: "\\Archive",
};

export const EMAIL_NOT_CONFIGURED_VARIANT = {
  REGULAR: "regular",
  LARGE: "large",
  SMALL: "small",
};

export const EMAIL_PARTICIPANTS_INPUT_FIELDS = {
  FROM: "FROM",
  TO: "TO",
  CC: "CC",
  BCC: "BCC",
};

export const EMAIL_ATTACHMENT_LIMIT_MB = 20;

export const MODULES = {
  EMAIL: "EMAIL",
  WORK_ORDER: "WORK_ORDER",
};

export const EMAIL_FOLDER_SORT = {
  [EMAIL_FOLDER_TYPES.INBOX]: 0,
  [EMAIL_FOLDER_ATTRIBUTE_TYPES.INBOX]: 0,
  [EMAIL_FOLDER_TYPES.DRAFT]: 1,
  [EMAIL_FOLDER_ATTRIBUTE_TYPES.DRAFT]: 1,
  [EMAIL_FOLDER_TYPES.SENT]: 2,
  [EMAIL_FOLDER_ATTRIBUTE_TYPES.SENT]: 2,
  [EMAIL_FOLDER_TYPES.OUTBOX]: 3,
  [EMAIL_FOLDER_ATTRIBUTE_TYPES.OUTBOX]: 3,
  [EMAIL_FOLDER_TYPES.TRASH]: 4,
  [EMAIL_FOLDER_ATTRIBUTE_TYPES.TRASH]: 4,
  [EMAIL_FOLDER_TYPES.SPAM]: 5,
  [EMAIL_FOLDER_ATTRIBUTE_TYPES.SPAM]: 5,
};

// Moved to @shared/ui/DocumentFileIcon; re-exported to keep oem's paths working.
export { SUPPORTED_EMAIL_FILE_EXTENSIONS } from "@shared/ui/DocumentFileIcon";
